import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useTokenStore from "store/tokenStore";

const useDeleteSubjectGroup = (subjectId) => {
	const { accessToken } = useTokenStore();
	const queryClient = useQueryClient();

	const history = useHistory();

	const toTrash = async () => {
		const instance = await InitApi({ accessToken });
		const response = await instance.delete(`/subject-groups/${subjectId}`);
		await queryClient.invalidateQueries("subject-groups");
		return response;
	};

	return useMutation(toTrash, {
		onSuccess: async () => {
			toast.success("Subject group deleted permanently");
		},
		onError: async (error) => {
			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);
		},
	});
};

export default useDeleteSubjectGroup;
